import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TEigyosyoListGetReq, TEigyosyoListGetRes } from "./TEigyosyo"

/**
 * 営業所マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class EigyosyoService
 * @extends {ConnectApi}
 */
export default class EigyosyoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getList = async (params?: TEigyosyoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TEigyosyoListGetRes>> =
        await this.getInner(`/master/eigyosyo`, params)
      return res.data
    } catch (error) {
      throw error
    }
  }
}
